import React from 'react';
import ContentEditor from './ContentEditor';
import { ProblemDescriptionEditorProps } from '../../types/components';

const ProblemDescriptionEditor: React.FC<ProblemDescriptionEditorProps> = ({
  value,
  onChange,
  isEditing,
  onEditToggle,
  onSave,
  onCancel,
  onAutoSave
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <ContentEditor
        value={value}
        onChange={onChange}
        placeholder="请详细描述您遇到的问题，包括问题的背景、现状和影响..."
        isEditing={isEditing}
        onEditToggle={onEditToggle}
        onSave={onSave}
        onCancel={onCancel}
        autoSave={true}
        onAutoSave={onAutoSave}
        label="问题描述"
        maxLength={2000}
        className="w-full"
      />
      

    </div>
  );
};

export default ProblemDescriptionEditor;